import { apiClient } from '@/shared/api/apiClient';
import { handleRequest } from '@/shared/api/apiWrapper';
import {
  type UserProfileInfoResponseDto,
  type UserScopeConfigurationFullResponseDto,
  type UserScopeConfigurationResponseDto,
} from './types';

export const getUserProfileInfo = async () => {
  const request = () => apiClient.get('/users/profile/info');
  const response = await handleRequest<UserProfileInfoResponseDto>(request);
  return response.data;
};

export const getUserScopeConfiguration = async () => {
  const request = () => apiClient.get('/users/scope/configuration');
  const response =
    await handleRequest<UserScopeConfigurationResponseDto>(request);
  return response.data;
};

export const getUserScopeConfigurationFull = async () => {
  const request = () =>
    apiClient.get('/users/scope/configuration', { params: { type: 'full' } });
  const response =
    await handleRequest<UserScopeConfigurationFullResponseDto>(request);
  return response.data;
};
